import React from 'react'
import ReactDOM from 'react-dom'
import { useConfig } from 'msp-integrations'
import { SpinnerFullProps } from './SpinnerFull.types'
import { twMerge } from 'tailwind-merge'

const SpinnerFull = ({
  colorScheme = 'dark',
  label,
  forbidBackgroundClick = false,
  show = false
}: SpinnerFullProps) => {
  const {
    theme: {
      mspComponents: { spinner }
    }
  } = useConfig()
  return show && typeof document !== 'undefined' ? (
    ReactDOM.createPortal(
      <div
        className={twMerge(
          `${`${forbidBackgroundClick || 'pointer-events-none'} fixed ${
            spinner.position
          } z-[9999] flex h-screen w-full items-center justify-center ${
            colorScheme === 'dark'
              ? spinner.fullscreenContainer.dark
              : spinner.fullscreenContainer.light
          }`}`
        )}
      >
        {spinner?.content}
        {label && (
          <div
            className={`absolute translate-y-20 px-4 text-center ${
              colorScheme === 'dark' ? spinner.label.dark : spinner.label.light
            }`}
          >
            {label}
          </div>
        )}
      </div>,
      document!.body
    )
  ) : (
    <></>
  )
}

export default SpinnerFull
